import {
  NotifContactRequestIcon,
  NotifContactRejectIcon,
  NotifProfileVerifApprovedIcon,
  NotifProfileVerifRejectedIcon,
  NotifPaymentPendingIcon,
  NotifPaymentReceivedIcon,
  NotifSearchFoundIcon,
  NotifWarningPackageExpireIcon,
  NotifPackageExpireIcon
} from 'assets'
import { MdClose } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'
import { putNotificationStatus } from 'api'
import { showErrorMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'

const NotificationContentCard = ({
  type = '',
  title = 'A Seller You a Contact Request',
  dateTime = '',
  message = 'A seller is interested in Medhurst Group. View the request and start the conversation now.',
  isRead = false,
  showIconClose = false,
  onClose,
  onAction,
  duration = 0,
  sourceId,
  refetch,
  id,
  source_table
}) => {
  const navigate = useNavigate()
  const contentType = {
    'contact-request-new': {
      icon: <NotifContactRequestIcon />,
      bgIcon: 'bg-info-light'
    },
    'contact-request-accepted': {
      icon: <NotifContactRequestIcon />,
      bgIcon: 'bg-info-light'
    },
    'contact-request-rejected': {
      icon: <NotifContactRejectIcon />,
      bgIcon: 'bg-error-light'
    },
    buyerContactRequestSent: {
      icon: <NotifContactRequestIcon />,
      bgIcon: 'bg-info-light'
    },
    buyerCtRequestRejected: {
      icon: <NotifContactRejectIcon />,
      bgIcon: 'bg-error-light'
    },
    'profile-accepted': {
      icon: <NotifProfileVerifApprovedIcon />,
      bgIcon: 'bg-success-light'
    },
    'profile-rejected': {
      icon: <NotifProfileVerifRejectedIcon />,
      bgIcon: 'bg-error-light'
    },
    'payment-pending': {
      icon: <NotifPaymentPendingIcon />,
      bgIcon: 'bg-surface-warning-light'
    },
    'payment-accepted': {
      icon: <NotifPaymentReceivedIcon />,
      bgIcon: 'bg-success-light'
    },
    'payment-accepted-event': {
      icon: <NotifPaymentReceivedIcon />,
      bgIcon: 'bg-success-light'
    },
    "payment-accepted-extra-bundle": {
      icon: <NotifPaymentReceivedIcon />,
      bgIcon: 'bg-success-light'
    },
    "payment-accepted-sponsorship": {
      icon: <NotifPaymentReceivedIcon />,
      bgIcon: 'bg-success-light'
    },
    'filter-match': {
      icon: <NotifSearchFoundIcon />,
      bgIcon: 'bg-brand-1'
    },
    'package-will-expired': {
      icon: <NotifWarningPackageExpireIcon />,
      bgIcon: 'bg-surface-warning-light'
    },
    'package-expired': {
      icon: <NotifPackageExpireIcon />,
      bgIcon: 'bg-error-light'
    }
  }

  const handleAction = (id) => {
    switch (type) {
      case 'contact-request-new':
        navigate('/profile/message/request')
        break
      case 'contact-request-accepted':
        navigate('/profile/message/request')
        break
      case 'contact-request-rejected':
        navigate('/profile/message/request')
        break
      case 'filter-match':
        navigate('/seller')
        break
      case 'profile-accepted':
        if (source_table == 'seller_profiles') {
          navigate('/profile/company-for-sale')
        } else if (source_table == 'buyer_profiles') {
          navigate('/profile/wanted-company')
        } else {
          navigate('/profile/advisor-information')
        }
        break
      case 'profile-rejected':
        if (source_table == 'seller_profiles') {
          navigate('/profile/company-for-sale')
        } else if (source_table == 'buyer_profiles') {
          navigate('/profile/wanted-company')
        } else {
          navigate('/profile/advisor-information')
        }
        break
      case 'payment-pending':
        navigate(`/profile/transaction/${id}/detail-transaction`)
        break
      case "payment-accepted-sponsorship":
        navigate(`/profile/transaction/${id}/detail-transaction`)
        break
      case "payment-accepted-extra-bundle":
        navigate(`/profile/transaction/${id}/detail-transaction`)
        break
      case 'payment-accepted-event':
        navigate(`/profile/transaction/${id}/detail-transaction`)
        break
      case 'payment-accepted':
        navigate(`/profile/transaction/${id}/detail-transaction`)
        break
      default:
        break
    }
  }

  const updateNotificationStatus = useMutation({
    mutationKey: 'updateNotificationStatus',
    mutationFn: () => putNotificationStatus(id),
    onSuccess: ({data}) => {
      if (refetch) {
        refetch();
      }
      handleAction(sourceId)
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })

  return (
    <div
      onClick={() => updateNotificationStatus.mutate()}
      className={`w-full p-4 flex flex-row items-start gap-2 ${
        showIconClose ? 'bg-white' : isRead ? 'bg-white' : 'bg-brand-1'
      }`}>
      <div
        className={`${contentType[type]?.bgIcon} w-[32px] h-[32px] rounded-full flex items-center justify-center shrink-0`}>
        {contentType[type]?.icon}
      </div>
      <div className="flex flex-col gap-2 flex-grow">
        <div>
          <p className="text-sm font-medium text-primary">{title}</p>
          <p className="text-xs text-secondary">{dateTime}</p>
        </div>
        <p className="text-xs text-primary">{message}</p>
        {type === 'contactRequest' && (
          <button
            onClick={onAction}
            className="border-none bg-white py-1 px-2 rounded text-primary w-fit text-xs font-medium no-underline">
            View Request
          </button>
        )}
      </div>
      {showIconClose && (
        <button onClick={onClose} className="border-none no-underline bg-white">
          <MdClose />
        </button>
      )}
      {duration > 0 && (
        <>
          <div className="w-full fixed bottom-0 left-0 h-[5px] bg-brand-1 rounded">
            <div
              className="h-full bg-surface-brand-2 rounded"
              style={{
                animation: 'progressAnimation 3s linear forwards'
              }}></div>
          </div>
          <style>
            {`
                @keyframes progressAnimation {
                  from {
                    width: 0%;
                  }
                  to {
                    width: 100%;
                  }
                }
              `}
          </style>
        </>
      )}
    </div>
  )
}

export default NotificationContentCard
